<template>
  <div
    v-for="attribute in filter.attributes"
    :id="`filter-range-${filter.key}-${attribute.key}`"
    :key="attribute.key"
    class="px-4"
  >
    <UiInput
      :id="`filter-range-${filter.key}-${attribute.key}-min`"
      v-model="minValue"
      :placeholder="$t('productList.filters.minRange')"
      :label="$t('productList.filters.minRange')"
      type="number"
      min="0"
      @update:model-value="minValue = minValue ? Math.abs(Number(minValue)).toString() : minValue"
      @change="
        updateValue(
          attribute.key,
          minValue !== '' || maxValue !== '' ? { min: Number(minValue), max: Number(maxValue) } : null,
        )
      "
    />
    <UiInput
      :id="`filter-range-${filter.key}-${attribute.key}-max`"
      v-model="maxValue"
      :placeholder="$t('productList.filters.maxRange')"
      :label="$t('productList.filters.maxRange')"
      type="number"
      min="0"
      @update:model-value="maxValue = maxValue ? Math.abs(Number(maxValue)).toString() : maxValue"
      @change="
        updateValue(
          attribute.key,
          minValue !== '' || maxValue !== '' ? { min: Number(minValue), max: Number(maxValue) } : null,
        )
      "
    />
  </div>
</template>

<script setup lang="ts">
import type { FilterProps, RangeFilter } from '~/components/ProductList/Filters/types';

const props = defineProps<FilterProps<RangeFilter, RangeFilter | null>>();

const minValue = ref(props.value?.min ?? '');
const maxValue = ref(props.value?.max ?? '');
</script>
